/** Min 8 chars, at least one upper, lower, digit, and special character. */
export const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

export const STRONG_PASSWORD_MESSAGE =
  'Password must be at least 8 characters and include uppercase, lowercase, a number, and a special character.';

export const PASSWORD_REQUIREMENTS = [
  'At least 8 characters',
  'One uppercase letter',
  'One lowercase letter',
  'One number',
  'One special character',
  'Does not match or significantly contain your user name',
];

export const PARTNER_ACTIVATE_PASSWORD_REQUIREMENTS = [
  'At least 8 characters',
  'One uppercase letter',
  'One lowercase letter',
  'One number',
  'One special character',
];

const normalizeForComparison = (value) =>
  String(value ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

export const getPasswordUsername = (profile) => {
  const emailLocal = profile?.email?.split('@')?.[0] ?? '';
  const fullName = profile?.fullName ?? '';
  return emailLocal || fullName;
};

export const passwordContainsUsername = (password, username) => {
  const normalizedUser = normalizeForComparison(username);
  const normalizedPass = normalizeForComparison(password);

  if (!normalizedUser || normalizedUser.length < 3) {
    return false;
  }

  return normalizedPass.includes(normalizedUser) || normalizedUser.includes(normalizedPass);
};

export const isStrongPassword = (password) => STRONG_PASSWORD_REGEX.test(String(password ?? ''));

export const getPasswordStrengthChecks = (password = '') => {
  const value = String(password ?? '');
  return {
    minLength: value.length >= 8,
    uppercase: /[A-Z]/.test(value),
    lowercase: /[a-z]/.test(value),
    number: /\d/.test(value),
    special: /[^A-Za-z0-9]/.test(value),
  };
};

export const validateChangePassword = ({
  currentPassword,
  newPassword,
  confirmPassword,
  username,
}) => {
  const errors = {};

  if (!currentPassword?.trim()) {
    errors.currentPassword = 'Current password is required.';
  }

  if (!newPassword?.trim()) {
    errors.newPassword = 'New password is required.';
  } else if (!isStrongPassword(newPassword)) {
    errors.newPassword = STRONG_PASSWORD_MESSAGE;
  } else if (passwordContainsUsername(newPassword, username)) {
    errors.newPassword = 'Password must not match or significantly contain your user name.';
  } else if (currentPassword && newPassword === currentPassword) {
    errors.newPassword = 'New password must be different from your current password.';
  }

  if (!confirmPassword?.trim()) {
    errors.confirmPassword = 'Please confirm your new password.';
  } else if (newPassword && newPassword !== confirmPassword) {
    errors.confirmPassword = 'Passwords do not match.';
  }

  return errors;
};

export const getPasswordUsernameFromEmail = (email) => {
  const local = String(email ?? '')
    .trim()
    .split('@')[0];
  return local || '';
};

/** First-time partner activation (no current password). */
export const validatePartnerActivatePassword = ({ password, confirmPassword, email } = {}) => {
  const errors = {};
  const username = getPasswordUsernameFromEmail(email);

  if (!password?.trim()) {
    errors.password = 'Password is required.';
  } else if (!isStrongPassword(password)) {
    errors.password = STRONG_PASSWORD_MESSAGE;
  } else if (passwordContainsUsername(password, username)) {
    errors.password = 'Password must not match or significantly contain your user name.';
  }

  if (!confirmPassword?.trim()) {
    errors.confirmPassword = 'Please confirm your password.';
  } else if (password && password !== confirmPassword) {
    errors.confirmPassword = 'Passwords do not match.';
  }

  return errors;
};
